<template>
  <div class="bg-white pt-3 border rounded shadow-sm text-start p-4">
    <div class="">
      <h3 class="text-l font-bold mb-4">
        Add administrator role
      </h3>
      <div class="">
        <label class="block text-sm leading-5 ">Name</label>
        <input type="text" v-model="name" :class="inputClass" placeholder="Role name"/>
      </div>

      <div class="my-3">
        <label class="block text-sm leading-5 mb-1 ">Role type<span class="text-red-700">*</span></label>
        <select :class="inputClass" class="bg-transparent" v-model="role_type">
          <option value="r_w">Full access</option>
          <option value="r">Read only</option>
          <option value="custom">Custom Permissions</option>
        </select>
      </div>
      <div class="my-3">
        <label class="block text-sm leading-5 mb-1">Description</label>
        <textarea v-model="description" :class="inputClass" placeholder="Describe..."></textarea>
      </div>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4" v-if="role_type === 'custom'">
        <div v-for="permission in permissions" v-bind:key="permission.id">
          <label class="block">
            <input class="mr-2 leading-tight" type="checkbox" :value="permission.identifier"
                   v-model="checkedPermissions">
            <span class="text-sm">
          {{ permission.name }}
      </span>
          </label>
        </div>
      </div>

      <div class="mt-6 text-right">
        <button type="submit" v-on:click="createRole"  v-if="$store.getters.can('create_roles')"
                class="py-2 px-4 bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
          Create
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import GraphQl from "@/services/graphql.service";

export default {
  name: "AddRoleComponent",
  props: {
    orgId: String
  },
  data() {
    return {
      loading: false,
      name: '',
      role_type: 'r',
      description: '',
      permissions: [],
      checkedPermissions: [],
      errors: [],
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'
    }
  },
  mounted() {
  },
  watch: {
    errors: function (errors) {
      this.$root.$emit("alert_error", errors);
    },
    role_type: function (type) {
      if (type === 'custom')
        this.getPermissions()
    }
  },
  methods: {
    createRole() {
      this.loading = true;
      this.errors = [];
      if (this.name == null || this.name === '')
        this.errors.push("Role name field is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

let params = 'name: "' + this.name + '", description: "' + this.description + '",role_type: "' + this.role_type + '", permissions: ' + JSON.stringify(this.checkedPermissions) + '';
      GraphQl.sendRequest('mutation{addRole('+params+') {code message}}')
          .then(response => {
            console.log(response)
          })
          .catch(error=>
          {
            console.log(error)
          })
          .finally(() => {
            this.loading = false;
          })
    },
    getPermissions() {
      this.loading = true
      // let params = 'limit: ' + this.recordsPerPage + ', offset: ' + this.offset + ', order: "created_at desc", search: "' + this.searchString + '"';
      GraphQl.sendRequest('{permissions {id name identifier description}}')
          .then(response => {
            this.permissions = response.permissions;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>

</style>